/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PutApiV1BannerIdMutationRequest,
  PutApiV1BannerIdMutationResponse,
  PutApiV1BannerIdPathParams,
  PutApiV1BannerId400,
  PutApiV1BannerId401,
  PutApiV1BannerId404,
  PutApiV1BannerId500,
} from "../../types/bannerRegistroController/PutApiV1BannerId.ts";
import { buildFormData } from "../../.kubb/config.ts";

function getPutApiV1BannerIdUrl(id: PutApiV1BannerIdPathParams["id"]) {
  const res = { method: "PUT", url: `/api/v1/banner/${id}` as const };
  return res;
}

/**
 * @description Atualiza os dados de um banner (multipart/form-data). Envie 'image' para substituir a imagem ou use os flags de remoção. **(Requer Authorization para autenticação)**
 * @summary Atualizar banner (Requer Authorization para autenticação)
 * {@link /api/v1/banner/:id}
 */
export async function putApiV1BannerId(
  id: PutApiV1BannerIdPathParams["id"],
  data?: PutApiV1BannerIdMutationRequest,
  config: Partial<RequestConfig<PutApiV1BannerIdMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;
  const formData = buildFormData(requestData);
  const res = await request<
    PutApiV1BannerIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1BannerId400
      | PutApiV1BannerId401
      | PutApiV1BannerId404
      | PutApiV1BannerId500
    >,
    PutApiV1BannerIdMutationRequest
  >({
    method: "PUT",
    url: getPutApiV1BannerIdUrl(id).url.toString(),
    data: formData as FormData,
    ...requestConfig,
  });
  return res.data;
}
